import { useMemo } from 'react'
import type { PermissionActionFilterInput, PermissionDecision, PermissionEvaluationInput, PermissionSurface } from '../types/permissions'
import type { PermissionAwareActionItem } from './types'
import { createDeniedDecision, filterPermissionAwareActions } from './evaluate'
import { usePermissionContext } from '../context/permission.context'

const fallbackSurface: PermissionSurface = {
  id: 'permission.fallback',
  entityKey: 'unknown',
  kind: 'context_action',
  denyMode: 'hide',
}

export const usePermission = () => usePermissionContext()

export const usePermissionDecision = (
  surface?: PermissionSurface,
  input?: PermissionEvaluationInput,
): PermissionDecision => {
  const { evaluateSurface } = usePermissionContext()

  return useMemo(() => {
    if (!surface) {
      return createDeniedDecision(fallbackSurface, 'permission_missing')
    }

    return evaluateSurface(surface, input)
  }, [evaluateSurface, input, surface])
}

export const usePermissionActionFilter = <T extends PermissionAwareActionItem>(
  items: T[] = [],
  input?: PermissionActionFilterInput,
): T[] => {
  const { snapshot } = usePermissionContext()

  return useMemo(() => filterPermissionAwareActions(snapshot, items, input), [input, items, snapshot])
}
